import { merge } from "lodash";
import {
  deductibleOptionsFormatted,
  doctorVisitOptionsFormatted,
  specialistVisitOptionsFormatted,
  planTypesFormatted,
  EMPTY_FILTERS,
} from "QuotePage/app/compactQuotePage/shared/FilterData";
import { SET_DENTAL_FILTER, RESET_DENTAL_FILTER } from "QuotePage/app/DentalQuotePage/Actions";
import { isRenewal } from "QuotePage/urls";

import {
  SET_SORT,
  SET_FILTER,
  RESET_FILTER,
  REFRESH_FILTERS,
  INITIAL_STATE_LOAD_REQUESTED,
  INITIAL_STATE_LOAD_SUCCESS,
  INITIAL_STATE_LOAD_FINISHED,
  RECOMMENDATION_SURVEY_LOADED,
  UPDATE_RECOMMENDED_PLANS,
  SET_LIMITED_VALUE_PLANS_FILTER,
  RESET_LIMITED_VALUE_PLANS_FILTER,
} from "./Actions";

export function asyncInitialState(
  state = {
    loading: true,
    loaded: false,
  },

  action,
) {
  switch (action.type) {
    case INITIAL_STATE_LOAD_REQUESTED:
      return { ...state, loading: true, loaded: false };

    case INITIAL_STATE_LOAD_SUCCESS:
      return { ...state, loading: false, loaded: false };

    case INITIAL_STATE_LOAD_FINISHED:
      return { ...state, loading: false, loaded: true };

    default:
      return state;
  }
}

export function sort(state = "", action) {
  switch (action.type) {
    case SET_SORT:
      return action.sort;
    default:
      return state;
  }
}

export function planTypes(state = [], action) {
  switch (action.type) {
    case INITIAL_STATE_LOAD_SUCCESS:
      return action.initialState.planTypes || state;
    default:
      return state;
  }
}

export function filters(state = EMPTY_FILTERS, action) {
  let newFilters = {};
  switch (action.type) {
    case INITIAL_STATE_LOAD_SUCCESS:
      if (!isRenewal()) {
        if (Object.keys(action.initialState.filters).length != 0) {
          return merge({}, state, action.initialState.filters);
        }
        newFilters = {
          deductible: {},
          plan_type: {},
          carrier: {},
          overflow_plan: {},
          "estimated_costs.pcp_visit": {},
          "estimated_costs.specialist_visit": {},
        };

        newFilters.deductible.ranges = deductibleOptionsFormatted;
        newFilters["estimated_costs.pcp_visit"].ranges = doctorVisitOptionsFormatted;
        newFilters["estimated_costs.specialist_visit"].ranges = specialistVisitOptionsFormatted;
        newFilters.carrier.include = action.initialState.carriersInRegion;
        const allPlanTypes = (planTypesFormatted + action.initialState.planTypes).uniq;
        newFilters.plan_type.include = allPlanTypes;
        newFilters.recommendation_mode = "shop_all_plans";
        newFilters.overflow_plan.include = [false];
        return merge({}, state, newFilters);
      }
      if (!state.recommendation_mode) {
        return merge({}, state, { recommendation_mode: "shop_all_plans" });
      }
      return state;
    case REFRESH_FILTERS:
      return merge({}, EMPTY_FILTERS, action.filters);
    case SET_FILTER:
      // note: might wanna look into immutable for dealing with nested states.
      newFilters = merge({}, EMPTY_FILTERS, JSON.parse(JSON.stringify(state)));
      newFilters[action.field] = action.rawValue;
      return newFilters;
    case SET_DENTAL_FILTER:
      newFilters = merge({}, EMPTY_FILTERS, JSON.parse(JSON.stringify(state)));
      newFilters.dentalFilter[action.field] = action.rawValue;
      return newFilters;
    case RESET_FILTER:
      return merge({}, EMPTY_FILTERS, {
        dentalFilter: state.dentalFilter,
        limitedValuePlansFilter: state.limitedValuePlansFilter,
        recommendation_mode: state.recommendation_mode,
      });

    case RESET_DENTAL_FILTER:
      newFilters = JSON.parse(JSON.stringify(state));
      newFilters.dentalFilter = EMPTY_FILTERS.dentalFilter;
      return newFilters;
    case SET_LIMITED_VALUE_PLANS_FILTER:
      newFilters = merge({}, EMPTY_FILTERS, JSON.parse(JSON.stringify(state)));
      newFilters.limitedValuePlansFilter[action.field] = action.rawValue;
      return newFilters;
    case RESET_LIMITED_VALUE_PLANS_FILTER:
      return merge({}, EMPTY_FILTERS, {
        limitedValuePlansFilter: state.limitedValuePlansFilter,
        recommendation_mode: state.recommendation_mode,
      });
    default:
      return state;
  }
}

export function recommendationSurvey(state = { isLoaded: false }, action) {
  switch (action.type) {
    case RECOMMENDATION_SURVEY_LOADED: {
      const newState = { ...state, isLoaded: true };
      return newState;
    }
    default:
      return state;
  }
}

export function recommendedPlans(state = [], action) {
  switch (action.type) {
    case UPDATE_RECOMMENDED_PLANS: {
      return action.payload;
    }
    default:
      return state;
  }
}
